import { takeEvery, select, call, put } from 'redux-saga/effects'
import { buildGETUrl } from '../../utilities/buildGETUrl'
import { addVideoToList, DELETE_VIDEOLISTS, DELETE_VIDEOS_FROM_VIDEOLIST, loadAllPublicVideo, loadVideolist, loadVideolists, putSongs, toggleSelectedVideo, updateVideolist as updateContentVideolist } from '../../store/ContentVideolists/actions'
import { showAlertError } from '../../store/Alert/actions'
import axios from 'axios'
import { loading } from '../../store/App/actions'
import { loadVideolistsAll, loadVideolistsAllById, toggleSelectedVideoAll, updateItem as updateContentVideoListFromAll } from '../../store/ContentAllVideolists/actions'

export default function* () {
    yield takeEvery(DELETE_VIDEOS_FROM_VIDEOLIST, worker)
}

function* worker(action) {
    const { videoListId, ids_to_delete } = action.payload

    console.log("DELETE_VIDEOS_FROM_VIDEOLIST", { action });


    yield put(loading(true))
    const {
        videoList_files,
        needUpdateFrom,
        needUpdateCurrent,
        selectedContent,
        selectedAll,
        contentSelectedId,
        currentVideolist
    } = yield select(state => ({
        videoList_files: state.videolists.selected[0] === videoListId ? state.videolists.songs : state.videolists_all.songs,
        needUpdateFrom: state.videolists_all.selected[0] ? state.videolists_all.selected[0] === videoListId : true,
        needUpdateCurrent: state.videolists_all.selected[0] ? state.videolists.selected[0] === videoListId : true,
        selectedContent: state.videolists.selected_video,
        selectedAll: state.videolists_all.selected_video,
        contentSelectedId: state.videolists.selected[0],
        currentVideolist: state.videolists.currentVideolist,


    }))

    try {

        const new_files_list = videoList_files
            .filter((item) => ids_to_delete.indexOf(item.id) === -1);
        const deleted = yield call(fetchDelete, { id: videoListId, songs: ids_to_delete })


        if (deleted.error) {
            yield put(showAlertError({
                errors: [`Ошибка сети при ${DELETE_VIDEOS_FROM_VIDEOLIST}.`, deleted],
                text: "Не все видео были удалены. Попробуйте заново."
            }))
        } else {
            if (needUpdateCurrent)
                yield put(putSongs(new_files_list))

            if (needUpdateFrom)
                yield put(loadVideolistsAllById({ offset: 0 }))
        }

        if (videoListId) {

            const videoListInfo = yield call(fetchVideoListInfo, videoListId)

            if (videoListInfo.error) {
                yield put(showAlertError({
                    errors: [`Ошибка сети при ${DELETE_VIDEOS_FROM_VIDEOLIST}.`, videoListInfo],
                    text: "Ошибка получения информации о видеолисте. Попробуйте перезагрузить страницу."
                }))
            } else {
                let videolist = { ...videoListInfo.success[0] }
                let totalsize2 = 0;
                if (videolist.totalsize) {
                    let size = Math.floor(videolist.totalsize / 1024 / 1024);
                    size = !size ? `${Math.floor(videolist.totalsize / 1024)} Kb` : `${size} Mb`
                    totalsize2 = size
                }
                videolist.totalsize2 = totalsize2
                videolist.songs = []

                yield put(updateContentVideoListFromAll(videolist))
                yield put(updateContentVideolist({ videolist }))

            }

        } else {
            yield put(loadVideolists())
            yield put(loadVideolistsAll())
            yield put(loadAllPublicVideo())



        }
        if (contentSelectedId)
            yield put(loadVideolist(contentSelectedId))
        if (needUpdateFrom) {
            const filtered = selectedAll.filter(el => ids_to_delete.indexOf(el) === -1);
            console.log("needUpdateFrom", filtered, selectedAll);

            if (filtered.length !== selectedAll.length) {
                yield put(toggleSelectedVideoAll({
                    setAll: true,
                    id_video: filtered
                }))
            }
        }
        if (needUpdateCurrent) {
            const filtered = selectedContent.filter(el => ids_to_delete.indexOf(el) === -1);
            console.log("needUpdateCurrent", filtered);

            if (filtered.length !== selectedContent.length) {
                yield put(toggleSelectedVideo({
                    setAll: true,
                    id_video: filtered
                }))
            }

        }
    }
    catch (e) {
        console.log({ e });

        yield put(showAlertError({
            errors: [`Ошибка сети при ${DELETE_VIDEOS_FROM_VIDEOLIST}.`, e],
            text: "Не все видео были удалены. Попробуйте заново."
        }))
    } finally {
        // if (!needUpdateFrom)
        yield put(loading(false))
    }

}

function fetchDelete(data) {
    let formData = new FormData();
    data.songs.forEach(songsId => {
        formData.append('id[]', songsId);
    });

    // formData.append('id_videolist', data.id);

    return axios({
        url: data.id ? `videolist/tracks/delete?id=${data.id}` : `videolist/tracks/delete`,
        method: "POST",
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    }).then((response) => response.data);
}

function fetchVideoListInfo(id) {
    return axios({
        url: `/videolist/select?id[]=${id}`,
        method: "GET",
        headers: {
            "Content-Type": "multipart/form-data",
        },
    }).then((response) => response.data);

}